import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Compute organization and invitation for Auth0 authorizationParams from URL/location.
 * Exported for testing.
 */
export function getAuth0AuthorizationParams(hostname, search, studyOrgId) {
  const urlParams = new URLSearchParams(search);
  const invitation = urlParams.get('invitation');
  const orgFromUrl = urlParams.get('organization');
  const isAppSubdomain = hostname.startsWith('app.') || hostname === 'localhost';
  const organization = orgFromUrl || (isAppSubdomain ? studyOrgId : undefined);
  return { organization, invitation };
}

/** MCP connector OAuth returns code/state on a dedicated path — do not consume as app login. */
export function shouldSkipAuth0RedirectCallback(pathname, search) {
  if (pathname === '/mcp-oauth/callback') return true;
  const params = new URLSearchParams(search || '');
  return params.has('mcp_oauth');
}

export const Auth0ProviderWithNavigate = ({ children }) => {
  const navigate = useNavigate();

  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const redirectUri = `${window.location.origin}/auth/callback`;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

  const { organization, invitation } = getAuth0AuthorizationParams(
    window.location.hostname,
    window.location.search,
    process.env.REACT_APP_STUDY_ORG_ID
  );

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  if (!(domain && clientId && redirectUri && audience)) {
    console.log("Auth0ProviderWithNavigate failed to load!");
    console.log("domain:", domain);
    console.log("clientId:", clientId);
    console.log("redirectUri:", redirectUri);
    console.log("audience:", audience);
    return null;
  }
  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: audience,
        ...(organization && { organization }),
        ...(invitation && { invitation, prompt: 'login' }),
      }}
      skipRedirectCallback={shouldSkipAuth0RedirectCallback(
        window.location.pathname,
        window.location.search,
      )}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
